export default __webpack_public_path__ + "static/media/KOD0129-min.1e814d18.webp";